export const LOAD_PRODUCTS_REQUEST = 'LOAD_PRODUCTS_REQUEST';
export const LOAD_PRODUCTS_SUCCESS = 'LOAD_PRODUCTS_SUCCESS';
export const LOAD_PRODUCTS_FAILURE = 'LOAD_PRODUCTS_FAILURE';

export const PAY_PRODUCT_REQUEST = 'PAY_PRODUCT_REQUEST';
export const PAY_PRODUCT_SUCCESS = 'PAY_PRODUCT_SUCCESS';
export const PAY_PRODUCT_FAILURE = 'PAY_PRODUCT_FAILURE';

export const PAY_PRODUCT_PRODUCT = 1;
export const PAY_PRODUCT_SUBSCRIPTION = 2;
